<template>
    <div v-if="essay_audios.length > 0">


        <b-card v-if="essay" class="mb-3">

            <template #header>
                Áudios
                <span v-b-tooltip.hover title="Aqui está um comentário(s) em áudio sobre o texto corrigido pelo professor">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                    </svg>
                </span>

            </template>

            <div class="mb-2" v-if="withoutCategoryAudios.length !== 0">
                <div class="pb-2 border-bottom" v-if="withoutCategoryAudios.length !== 0 && withCategoryAudios.length !== 0" >Sem categoria</div>
                <div class="py-2 px-3 bg-light text-black-50" v-if="withoutCategoryAudios.length === 0">
                    Nada por aqui...
                </div>
                <div v-for="essay_audio in withoutCategoryAudios" :key="essay_audio.id">
                    <div class="py-2 d-flex align-items-center justify-content-between">
                        <audio v-if="essay_audio.converted_preview" class="d-flex audio m-0 p-0" controls>
                            <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                            <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                        </audio>
                    </div>

                </div>
            </div>

            <div class="mb-2">
                <div v-for="category in withCategoryAudios" :key="category.id">
                    <div class="pb-2 border-bottom">{{ category.name}}</div>
                    <div v-for="essay_audio in category.essay_audios" :key="essay_audio.id">
                        <div class="py-2 d-flex align-items-center justify-content-between">
                            <audio v-if="essay_audio.converted_preview" class="d-flex audio m-0 p-0" controls>
                                <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                                <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                            </audio>

                        </div>

                    </div>
                </div>
            </div>

            <!--

                <div v-for="essay_audio in essay_audios" :key="essay_audio.id">

                    <div class="d-flex mb-2">
                        <audio class="d-flex audio" controls>
                            <source v-if="essay_audio.converted_preview" :src="essay_audio.converted_preview" />
                            <source v-if="essay_audio.original_preview" :src="essay_audio.original_preview" />
                        </audio>
                    </div>

                </div>
            -->

        </b-card>
    </div>
</template>

<script>
export default {

    props: ['essay'],

    data() {
        return {
            loading: false,
            essay_audios: [],
            withCategoryAudios: [],
            withoutCategoryAudios:[],
        }
    },

    created() {

        this.load()

    },

    methods: {

        load() {
            this.loading = true;
            axios.get('/student/essay-audios/' + this.essay.id)
                .then((result) => {
                    this.essay_audios = result.data.data.essay_audios;

                    let withCategoryAudios = []
                    let withoutCategoryAudios = []


                    this.essay_audios.forEach((audio)=>{
                        if(audio.essay_audio_category_id){

                            if(!withCategoryAudios.find(cate=> cate.id === audio.essay_audio_category_id )){
                                withCategoryAudios.push({...audio.essay_audio_category, essay_audios: []})

                            }
                            withCategoryAudios.forEach((cate, index)=> {
                                if(audio.essay_audio_category_id === cate.id){
                                    withCategoryAudios[index].essay_audios.push({...audio})
                                }
                            })
                        }
                        else{

                            withoutCategoryAudios.push(audio)
                        }

                    })
                    this.withCategoryAudios = withCategoryAudios
                    this.withoutCategoryAudios = withoutCategoryAudios
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>
    .icons{
        height: 20px;
    }
</style>
